import { render } from "./OtsDialog.vue?vue&type=template&id=4014ea5a&scoped=true&ts=true"
import script from "./OtsDialog.vue?vue&type=script&lang=ts"
export * from "./OtsDialog.vue?vue&type=script&lang=ts"

import "./OtsDialog.vue?vue&type=style&index=0&id=4014ea5a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4014ea5a"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinnerFacebook from 'quasar/src/components/spinner/QSpinnerFacebook.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QSpinnerFacebook,QChip});
